import RegistrationForm from '../../../components/pages/users/RegistrationForm.vue'

export default {
  components: { RegistrationForm }
}
